<template>
  <div class="dialog-wrap">
    <el-dialog title="角色分配"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="480px">
      <el-form class="form"
               :model="dataForm"
               ref="dataForm"
               label-width="100px">
        <el-form-item label="选择角色"
                      prop="roles">
          <el-select v-model="dataForm.roles"
                     multiple
                     placeholder="请选择"
                     @change="change">
            <el-option v-for="item in options"
                       :key="item.id"
                       :label="item.title"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  adminCreate,
  adminRoleList,
  adminUpdate,
  adminPermissions,
} from '@/api/admin'
import { setStorage, getStorage } from '@/utils/helper'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: {
        roles: [],
        id: '',
      },
      options: [],
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    content(val) {
      if (val) {
        if (val.roles.length > 0) {
          this.dataForm.roles = val.roles.split(',').map((v) => Number(v))
        } else {
          this.dataForm.roles = []
        }
        this.dataForm.id = val.id
        this.fetchAdminRoleList()
      }
    },
  },
  methods: {
    handleSubmit() {
      const params = Object.assign({}, this.dataForm, {
        roles: String(this.dataForm.roles),
      })
      adminUpdate(params)
        .then((res) => {
          const userInfo = getStorage('admin_user')
          if (this.dataForm.id == userInfo.id) {
            adminPermissions({ admin_id: this.dataForm.id }).then((res) => {
              setStorage('admin_permissions', res.list)
            })
          }
          this.$message.success(`添加成功`)
          this.$refs['dataForm'].resetFields()
          this.$emit('submit')
          this.handleClose()
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    fetchAdminRoleList() {
      adminRoleList({ isPaing: 0 }).then((res) => {
        this.options = res.list
      })
    },
    handleClose() {
      this.dataForm.roles = []
      this.$emit('close')
    },
    change(val) {
      this.dataForm.roles = val
    },
  },
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .form {
    margin-bottom: -18px;
  }
}
</style>
